import React from "react";
import { FastField } from "formik";

import { NumberField } from "../../../../../../elements/FormField";
import { numberValidator } from "../../../../../../utils/formValidators";

const MeasuringRange = ({ prefix }) => (
  <FastField
    component={NumberField}
    name={`${prefix}.measuringRange`}
    validate={numberValidator({ min: 0, max: 2000 })}
    min={0}
    max={2000}
  />
);

export default MeasuringRange;
